import {AxiosError} from 'axios';
import {has} from 'ramda';
import {ErrorCode as ApiErrorCode} from '../types/error/ErrorCode';

export const isUnauthenticatedError = (error: AxiosError) => {
  return has('response', error) &&
    has('data', error.response) &&
    has('errorCode', error.response.data) &&
    error.response.data.errorCode == ApiErrorCode.UNAUTHENTICATED;
}